<template>
    <div class="pt-3 px-4" v-if="refresh">
        <InputText
                v-model:inputValue="addressModel.addressName"
                :errorInfo="errorInfo[0]"
                :isShowError="false"
                :isSubmitted="isSubmitted"
                :maxLength="50"
                :inputLbl="lbl.shipping.addressName"
        ></InputText>
        <InputText
                v-model:inputValue="addressModel.building"
                :errorInfo="errorInfo[1]"
                :isShowError="false"
                :isSubmitted="isSubmitted"
                :maxLength="50"
                :inputLbl="lbl.shipping.building"
        ></InputText>
        <div class="pb-4">
            <div class="p-3.5 bg-a-brown-e7d7c1 rounded-10">
                <div class="text-12 text-a-brown-9f8273 pb-2">{{lbl.shipping.address}}</div>
                <div class="text-14 text-a-brown-502314">
                    {{addressModel.number}}
                    {{addressModel.soi}}
                    {{addressModel.subDistrictName}}
                    {{addressModel.districtName}}
                    {{addressModel.provinceName}}
                    {{addressModel.zipcode}}
                </div>
            </div>
        </div>
        <Checkbox
                v-model:check="addressModel.isDefault"
                :text="lbl.shipping.isDefaultAddress"
        ></Checkbox>
    </div>
</template>
<script>
// import Util from "@/helper/Utility.js";
import { FormHelper } from "@/helper/FormHelper.js";
//component
import InputText from "@/components/Input/label/InputText.vue";
import Checkbox from "@/components/Input/simple/Checkbox.vue";
//import FormAddressDropdown from "@/components/Form/FormAddressDropdown.vue";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from '@/mixin/ModalMixin.js';
//service
//import { AddressModel } from "@/core/Address/model/AddressModel.js";
import { AddressListModel } from "@/core/Address/model/AddressListModel.js";

export default {
    name: "FormDeliveryAddress",
    inject: ['DeliveryStore'],
    mixins: [LocaleMixin,ModalMixin],
    components: {
        InputText,
        Checkbox,
        //FormAddressDropdown,
    },
    data: function() {
        return {
            isSubmitted: false,
            errorInfo: [],
            refresh: true,

            formAddressModel: null,
            addressModel: null,
        };
    },
    created: function() {
        if (!this.DeliveryStore.state.address || !this.DeliveryStore.state.address.lat || !this.DeliveryStore.state.address.lng) {
            this.$router.back();
        }

        this.initForm(this.DeliveryStore.state.address);
        this.errorInfo = FormHelper.genErrorInfo(6);
    },
    methods: {
        initForm: function(address) {
            this.isSubmitted = false;

            if (address != null) {
                this.addressModel = {...address};
                //this.formAddressModel.setValueFromAddressListModel(this.addressModel);
            } else {
                this.addressModel = new AddressListModel();
                //this.formAddressModel = new AddressModel();
            }

            this.refresh = false;
            this.$nextTick(() => {
                this.refresh = true;
            });
        },
        clearForm: function() {
            this.initForm(null);
        },
        submitForm: function() {
            this.isSubmitted = true;
            if (this.validate()) {
                //this.addressModel.setValueFromAddressModel(this.formAddressModel);
                return this.addressModel;
            } else {
                this.modal.errorModal.clearModal()
                                    .setMsg(FormHelper.getFirstErrorItem(this.errorInfo).msg)
                                    .show();
            }
            return null
        },
        validate: function() {
            return FormHelper.validate(this.errorInfo);
        },
    },
}
</script>
